import createAxios from '../axiosHttp';

function getPackages(pagination,filters) {
    const axios = createAxios();
    let urlPath = `administration/package`;
    if (pagination) {
        urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
    } else {
        urlPath += '?page=0&limit=20';
    }
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.sort) {
        if(filters.sort.sort){
            urlPath += `&sort=${filters.sort.sort}`;
        }
        if(filters.sort.order){
            urlPath += `&order=${filters.sort.order}`;
        }
    }
    return axios.get(urlPath);
}
function deletePackage(id){
    const axios = createAxios();
    let urlPath = `administration/package/${id}`;
    return axios.delete(urlPath);
}
function newPackage(body){
    const axios = createAxios();
    let urlPath = `administration/package`;
    return axios.post(urlPath, body);
}

export const packagesService = { getPackages,deletePackage,newPackage};